export default "__VITE_ASSET__BzXyqM3g__"